/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Storefront_Not_FoundInputs */

const en_storefront_not_found = /** @type {(inputs: Storefront_Not_FoundInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Storefront Not Found`)
};

const es_storefront_not_found = /** @type {(inputs: Storefront_Not_FoundInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tienda no encontrada`)
};

const fr_storefront_not_found = /** @type {(inputs: Storefront_Not_FoundInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vitrine introuvable`)
};

const de_storefront_not_found = /** @type {(inputs: Storefront_Not_FoundInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Storefront nicht gefunden`)
};

const ja_storefront_not_found = /** @type {(inputs: Storefront_Not_FoundInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ストアフロントが見つかりません`)
};

const zh_storefront_not_found = /** @type {(inputs: Storefront_Not_FoundInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`未找到店铺`)
};

const ar_storefront_not_found = /** @type {(inputs: Storefront_Not_FoundInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`واجهة المتجر غير موجودة`)
};

const id_storefront_not_found = /** @type {(inputs: Storefront_Not_FoundInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Etalase Tidak Ditemukan`)
};

const it_storefront_not_found = /** @type {(inputs: Storefront_Not_FoundInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vetrina Non Trovata`)
};

const ru_storefront_not_found = /** @type {(inputs: Storefront_Not_FoundInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Витрина не найдена`)
};

const pt_storefront_not_found = /** @type {(inputs: Storefront_Not_FoundInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vitrine Não Encontrada`)
};

const ko_storefront_not_found = /** @type {(inputs: Storefront_Not_FoundInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`스토어프론트를 찾을 수 없습니다`)
};

/**
* | output |
* | --- |
* | "Storefront Not Found" |
*
* @param {Storefront_Not_FoundInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const storefront_not_found = /** @type {((inputs?: Storefront_Not_FoundInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Storefront_Not_FoundInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_storefront_not_found(inputs)
	if (locale === "es") return es_storefront_not_found(inputs)
	if (locale === "fr") return fr_storefront_not_found(inputs)
	if (locale === "de") return de_storefront_not_found(inputs)
	if (locale === "ja") return ja_storefront_not_found(inputs)
	if (locale === "zh") return zh_storefront_not_found(inputs)
	if (locale === "ar") return ar_storefront_not_found(inputs)
	if (locale === "id") return id_storefront_not_found(inputs)
	if (locale === "it") return it_storefront_not_found(inputs)
	if (locale === "ru") return ru_storefront_not_found(inputs)
	if (locale === "pt") return pt_storefront_not_found(inputs)
	return ko_storefront_not_found(inputs)
});